import { render, staticRenderFns } from "./DynamicFormsList.vue?vue&type=template&id=0d949056&"
import script from "./DynamicFormsList.vue?vue&type=script&lang=js&"
export * from "./DynamicFormsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports